<!--First the retail list is loaded, Second filters, and last the grid. This ui serves data analysis
for product WM, stock break and commercail agreements. To render the ui, each kpi pass the following:
headerComponent, viewClientName, parameters for request, value mapping -->
<template>
  <div>
    <loading :active.sync="isLoading"
             loader="dots"
             color="blue"
             :opacity="0.6"
             :is-full-page="true"/>
    <FilterPane :height="vuexAvailableHeight - 190"/>
    <b-card border-variant="light" class="mb-0" no-body>
      <Header :header-info="headerInfo" :header-title="childHeaderTitle" :excel-parameters="childExcelParameters"/>
      <b-container fluid class="p-0">
        <b-row no-gutters>
          <b-col cols="2">
            <RetailListSelector/>
          </b-col>
          <b-col cols="10">
            <DimensionFilter/>
            <GridMetricSystemWideOneMetric :grid-height="vuexAvailableHeight"/>
          </b-col>
        </b-row>
      </b-container>
      <b-modal id="modal-gkka" :ok-only="true" @ok="openFilterPaneForUser">
        <div class="d-block">No existen datos</div>
      </b-modal>
    </b-card>
  </div>
</template>


<script>
  import { DimensionUtils, GeneralUtils, FilterObjectParameterBuilder } from '@/mixins/index'
  import GridMetricSystemWideOneMetric from '../components/GridSystems/GridMetricSystemWideOneMetric'
  import DimensionFilter from '../components/DimensionFilterQuickAccess/DimensionFilterQuickAccess'
  import RetailListSelector from '../components/GeneralKeyKpiAnalysis/RetailListSelector'
  import { reportParameters } from '../../expertoRetail/library/requestParameters/generalKeyApiAnalysisRequestParameters'
  import ProductWmHeader from '../components/GeneralKeyKpiAnalysis/ProductWmHeader'
  import PriceAuditionHeader from '../components/GeneralKeyKpiAnalysis/PriceAuditionHeader'
  import FilterPane from '../components/FilterPane/FilterPane'
  import {sales} from '../../services/api/ExpertoRetail'
  import ExpertoRetailLoader from '../atoms/ExpertoRetailLoader'
  import Header from '../components/GeneralKeyKpiAnalysis/Header'
  export default {
    name: 'GeneralKeyKpiAnalysis',
    mixins: [GeneralUtils, DimensionUtils, FilterObjectParameterBuilder],
    components: {
      GridMetricSystemWideOneMetric,
      DimensionFilter,
      RetailListSelector,
      ProductWmHeader,
      PriceAuditionHeader,
      FilterPane,
      ExpertoRetailLoader,
      Header
    },
    data () {
      return {
        isLoading: false,
        headerInfo: '',
        headerTitle: ''
      }
    },
    created () {
      this.$eventHub.$on('grid-metric-wide-one-metric-is-ready', this.initLoad)
      this.$eventHub.$on('index-filter-new-selection', this.atIndexDimFilterChangeLoad)
      this.$eventHub.$on('filter-pane-filter-update', this.initLoad)
      // this.$store.commit('commit_filterPane_resetState')
      this.commitGridCellClass()
    },
    beforeDestroy () {
      this.$eventHub.$off('grid-metric-wide-one-metric-is-ready')
      this.$eventHub.$off('index-filter-new-selection')
      this.$eventHub.$off('filter-pane-filter-update', () => {})
    },
    watch: {
      vuexGlobalFilters () {
        this.buildParameters()
      },
      conditionValue (val) {
        this.$store.commit('commit_gridMetricSystemWideOneMetric_cellCondition', val)
      },
      gridCellClicked () {
        this.goToClickedCellView()
      },
      vuexSelectedRetail (id) {
        let configParams = this.$store.getters.clientBusinessParameters.find(x => x.retail_id === id)
        this.headerInfo = reportParameters[this.vuexSelectedReport].headerInfo(configParams)
        this.commitRetailMetricConditions(id)
        this.atRetailChangeLoad()
      }
    },
    computed: {
      vuexGlobalFilters () {
        return this.$store.state.globalFilters
      },
      vuexSelectedRetail () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.selectedRetail)
      },
      vuexSelectedReport () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.selectedReport)
      },
      headerComponent () {
        return reportParameters[this.vuexSelectedReport].headerComponent
      },
      gridCellClicked () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.gridMetricSystemWideOneMetric.cellClicked)
      },
      vuexAvailableHeight () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.appAvailableHeight - 96)
      },
      retailBusinessParameters () {
        return this.$_generalUtils_deepJsonCopy(this.$store.getters.clientBusinessParameters)
      },
      vuexFilterObjectActiveInstance () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.filterRequestObject.activeFilterObjectInstance)
      },
      vuexSelectedIndexDimFilter () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.dimensionFilterQuickAccess.selectedIndexItem)
      },
      vuexClientDimensionFilter () {
        let dim = this.$store.state.desktopParameterConfig.dimensionFilter.dimValue
        return this.$_generalUtils_deepJsonCopy(dim)
      },
      childHeaderTitle () {
        return reportParameters[this.vuexSelectedReport].headerName
      },
      childExcelParameters () {
        return reportParameters[this.vuexSelectedReport].excelParameters
      }
    },
    methods: {
      goToClickedCellView () {
        let view = reportParameters[this.vuexSelectedReport].atCellClickedGoToView
        this.$router.push({'name': view})
      },
      commitGridCellClass () {
        let cellClass = reportParameters[this.vuexSelectedReport].gridCellClass
        this.$store.commit('commit_gridMetricSystemWideOneMetric_cellCondition', cellClass)
      },
      commitRetailMetricConditions (id) {
        let selectedRetailConfigParam = this.retailBusinessParameters.find(x => x.retail_id === id)
        this.$store.commit('commit_genKeyKpiAnalysis_selectedRetailBusinessParameters', selectedRetailConfigParam)
      },
      defaultParameterBuild (reportParams) {
        let a = this.$_generalUtils_deepJsonCopy(this.vuexFilterObjectActiveInstance)
        if (Object.keys(a).length === 0 || a === undefined || a === null) {
          this.isLoading = false
          throw new Error('vuexFilterObjectActiveInstance cant be empty')
        }
        let parameters = reportParameters[this.vuexSelectedReport].requestParameters[reportParams]
        parameters.parameters = {...parameters.parameters, ...a}
        return parameters
      },
      setRetailSelectorActiveItem (response) {
        // let a = this.vuexSelectedRetail
        let retailId = response.data[0]['retail_id']
        this.$store.commit('commit_genKeyKpiAnalysis_selectedRetail', retailId)
        let configParams = this.$store.getters.clientBusinessParameters.find(x => x.retail_id === retailId)
        this.headerInfo = reportParameters[this.vuexSelectedReport].headerInfo(configParams)
      },
      setDimensionFilterActiveItem (response) {
        let a = this.vuexSelectedIndexDimFilter
        let firstItem = response[0]['metadata']
        if (a === undefined || a === null) {
          this.$store.commit('commit_dimensionFilterQuickAccess_selectedIndexItem', firstItem)
        }
      },
      toggleFilterPane () {
        this.$root.$emit('bv::toggle::collapse', 'filter-pane-collapse')
      },
      showModal () {
        this.$root.$emit('bv::show::modal', 'modal-gkka')
      },
      hideModal () {
        this.$root.$emit('bv::hide::modal', 'modal-gkka')
      },
      openFilterPaneForUser () {
        this.toggleFilterPane()
        this.hideModal()
      },
      initLoad () {
        this.isLoading = true
        this.retailSelectorFetchData()
          .then(this.dimensionFilterFetchData, this.chainError)
          .then(this.gridFetchData)
          .finally(() => {
            this.isLoading = false
          })
      },
      atRetailChangeLoad () {
        this.isLoading = true
        this.dimensionFilterFetchData()
          .then(this.gridFetchData, this.chainError)
          .finally(() => {
            this.isLoading = false
          })
      },
      atIndexDimFilterChangeLoad () {
        this.isLoading = true
        this.gridFetchData()
          .finally(() => {
            this.isLoading = false
          })
      },
      chainError (mth) {
        this.$store.commit('commit_dimensionFilterQuickAccess_selectedIndexItem', [])
        this.$store.commit('commit_genKeyKpiAnalysis_gridData', {'data': []})
        this.isLoading = false
        this.showModal()
      },
      retailSelectorFetchData () {
        // Default parameter build
        let fn = 'retailSelector'
        let parameters = this.$_generalUtils_deepJsonCopy(this.defaultParameterBuild(fn))

        this.loading = true
        return new Promise((resolve, reject) => {
          sales.salesTwoRanges(parameters)
            .then(response => {
              let a = response
              this.$store.commit('commit_genKeyKpiAnalysis_retailListSelectorData', a)
              this.setRetailSelectorActiveItem(a)
              resolve(true)
            })
            .catch(() => {
              this.chainError()
              throw new Error('Retail selector')
            })
        })
      },
      dimensionFilterFetchData () {
        // Default parameter build
        let fn = 'dimensionFilter'
        let parameters = this.$_generalUtils_deepJsonCopy(this.defaultParameterBuild(fn))

        // Custom parameter
        parameters.parameters.product_dimensions = [this.vuexClientDimensionFilter]
        let a = this.vuexSelectedRetail
        if (a === undefined || a === null) {
          throw new Error('selected retail not define')
        } else {
          parameters.parameters.store_filters.retail_id = [a]

          return new Promise((resolve, reject) => {
            sales.dimFilter(parameters)
              .then(response => {
                this.$store.commit('commit_genKeyKpiAnalysis_dimensionFilterData', response)
                this.setDimensionFilterActiveItem(response)
                resolve(true)
              })
              .catch(() => {
                this.chainError('dimfilter data')
                throw new Error()
              })
              .finally(() => {
              })
          })
        }
      },
      gridFetchData () {
        // Default parameter build
        let fn = 'grid'
        let parameters = this.$_generalUtils_deepJsonCopy(this.defaultParameterBuild(fn))

        // Custom parameter
        parameters.parameters.store_filters.retail_id = [this.vuexSelectedRetail]
        let a = this.vuexSelectedIndexDimFilter
        parameters = this.$_filterObjectParameterBuilder_mergeFilterInstanceWithDimensionFilter(parameters, a)

        return new Promise((resolve, reject) => {
          sales.pivotSales(parameters, parameters)
            .then(response => {
              this.$store.commit('commit_genKeyKpiAnalysis_gridData', response)
              this.$eventHub.$emit('grid-metric-wide-one-metric-fetch-data')
              this.isLoading = false
              resolve()
            })
            .catch((e) => {
              this.chainError()
              throw new Error(e)
            })
            .finally(() => {
            })
        })
      }
    }
  }
</script>

<style scoped>

.inline-block {
  margin: 0 auto;
  display: inline-flex;
}

</style>



// WEBPACK FOOTER //
// src/expertoRetail/views/GeneralKeyKpiAnalysis.vue